"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEATMAP_URL = void 0;
exports.HEATMAP_URL = "https://static.sensorsdata.cn/sdk/1.10.9/heatmap.min.js";
